<template>
  <div class="tree">
    <tree-node
      v-for="(nodeData, idx) of treeData"
      :nodeData="nodeData"
      :id="nodeData.id"
      :key="idx">
    </tree-node>
  </div>
</template>

<script>
import treeNode from './tree-node'

export default {
  components: {
    treeNode
  },
  props: {
    treeData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isTreeRoot: true
    }
  }
}
</script>
